/**
 * @flow
 */

import React from 'react';
import styled from 'styled-components';
import { Icon } from 'semantic-ui-react';

import { PhoneInput as BasePhoneInput } from '../../../../components';

const PhoneInput = styled(BasePhoneInput)`
    &.disabled {
        &,
        input:disabled,
        .disabled {
            opacity: 1 !important;
            background-color: #fffaf3;
        }
    }
`;

export default function PhoneField({ userLookupStatus, onUserLookup, resetUserLookup, disabled, ...props }) {
    return (
        <PhoneInput
            {...props}
            disabled={disabled}
            className={disabled ? 'disabled' : ''}
            icon={
                userLookupStatus === 'EXISTS' && (
                    <Icon name="checkmark" color="green" inverted={true} circular={true} />
                )
            }
            loading={userLookupStatus === 'CHECKING'}
        />
    );
}
